<template>
  <b-card>
    <div>
      <Strong>HUB-Wise Performance Report</Strong>

      <b-row class="mt-4">
        <b-col >                    
          <div>
            <ul class="nav nav-tabs nav-justified">
              <li class="nav-item">
                <a @click="activeTab = 1;" class="nav-link" :class="{'active' : isActiveTab(1)}" >OFD Report</a>
              </li>

              <li class="nav-item">
                <a @click="activeTab = 2;" class="nav-link " :class="{'active' : isActiveTab(2)}">OFP Report</a>
              </li>            
            </ul>
          </div>                       
        </b-col>
      </b-row>

      <component :is="currentComponent" class="mt-4"></component>
    </div>
  </b-card>
</template>
  
<script>
import hubWiseOFDReport from './hubWiseOFDReport.vue';
import hubWiseOFPReport from './hubWiseOFPReport.vue';

  export default {
    components: {
      hubWiseOFDReport,
      hubWiseOFPReport
    },
    data: function(){
      return{
        activeTab: 1,
        name: 'hubWisePerformanceReport',
      }
    },
    computed : {
      currentComponent() {
        if(this.activeTab === 1)           
          return "hubWiseOFDReport";
        else
          return "hubWiseOFPReport";
      }
    },

    created: function(){
      this.isActiveTab(1);
    },
    methods:{
      isActiveTab(id)
      {
        return this.activeTab === id;
      }
    }
  };
</script>

<style>

</style>
  